import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useProjectsFiltersStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      boxShadow: '0px 4px 25px rgba(0, 0, 0, 0.1)',
      borderRadius: 13,

      [theme.breakpoints.down(960)]: {
        boxShadow: 'none'
      }
    },

    button: {
      marginTop: 32,
      marginLeft: 'auto'
    },

    buttonAdd: {
      marginTop: '43px',
      textTransform: 'none',
      width: 'fit-content'
    },

    linkAdd: {
      width: 'fit-content'
    },

    row: {
      width: '100%',
      display: 'block',
      marginBottom: 0
    },

    rowNew: {
      margin: 0,
      fontSize: 14,
      textDecoration: 'underline'
    },

    buttonFilters: {
      padding: 0,
      textTransform: 'none',
      textDecoration: 'underline',
      fontWeight: 400,
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: 'transparent'
      }
    },

    btn: {
      padding: 0
    },

    dropdown: {
      zIndex: 9999
    },

    negotiatedRow: {
      marginBottom: 0
    },

    costRow: {
      marginBottom: 0
    },

    input: {
      margin: 0
    },

    checkboxlabel: {
      fontSize: '14px'
    },

    card: {
      marginTop: theme.spacing(3)
    },

    accordion: {
      width: '100%',
      display: 'block',

      '&$accordionExpanded': {
        margin: '12px 0',
        boxShadow: 'none'
      }
    },

    costAccordion: {
      paddingBottom: 0
    },

    costAccordionDetails: {
      paddingBottom: 0
    },

    accordionExpanded: {},

    accordionSummaryExpanded: {},

    accordionSummaryContent: {
      '&$accordionSummaryExpanded': {
        margin: 0
      }
    },

    accordionSummary: {
      '&$accordionSummaryExpanded': {
        minHeight: 'auto'
      }
    },

    details: {
      width: '100%',
      display: 'block',
      margin: '0px !important'
    },

    delimeter: {
      margin: theme.spacing(0, 2),
      display: 'flex',
      alignItems: 'center'
    },

    slider: {
      width: '91% !important',
      marginTop: theme.spacing(3),
      '& MuiSlider-root': {
        width: '91% !important'
      },
      '& .MuiSlider-thumb': {
        width: '40px',
        height: '40px',
        marginTop: '-20px'
      },

      '& .MuiSlider-thumb:hover': {
        zIndex: 9999
      },
      '& .MuiSlider-thumb:focus': {
        zIndex: 9999
      },
      '& .MuiSlider-valueLabel': {
        position: 'absolute',
        top: '35%',
        left: '10%',
        color: 'transparent',
        fontSize: 16
      }
    },

    ProjectsCaregories: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%'
    },

    sort: {
      width: 332,
      border: '1px solid rgba(0, 0, 0, 0.36)',
      borderRadius: '4px',
      '& .MuiInput-underline::before': {
        borderBottom: 'none !important'
      },
      '& .MuiInput-underline::after': {
        borderBottom: 'none !important'
      },
      ['& div div']: {
        fontFamily: 'Montserrat',
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '17px',
        letterSpacing: '0em',
        padding: '8px 0px 10px 18px'
      },

      [theme.breakpoints.down(1441)]: {
        width: 265
      },
      [theme.breakpoints.down('xs')]: {
        margin: 0
      }
    },
    mobileSort: {
      height: '44px',
      border: 'none',
      padding: '0px 16px',
      display: 'flex',
      justifyContent: 'center',
      '& .MuiInput-underline::before': {
        borderBottom: 'none !important'
      },
      '& .MuiInput-underline::after': {
        borderBottom: 'none !important'
      },

      ['& div div']: {
        fontFamily: 'Montserrat',
        fontSize: '14px',
        color: '#4F4F4F',
        fontWeight: 500,
        lineHeight: '17px',
        letterSpacing: '0em',
        padding: '10px 0px 10px'
      }
    },

    filterTitle: {
      fontFamily: 'Montserrat',
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '15px',
      letterSpacing: '0em'
    },
    filterIcon: {
      cursor: 'pointer',
      minWidth: '16px',

      [theme.breakpoints.up(600)]: {
        marginRight: '12px'
      }
    },
    mobileFiltersBox: {
      position: 'relative',
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      background: 'white',
      padding: '0 17px 0 32px',
      borderRadius: '6px',
      boxShadow: '0px 4px 25px rgba(0, 0, 0, 0.1)',

      [theme.breakpoints.down(600)]: {
        padding: '0 16px 0px 16px'
      }
    },
    popover: {
      marginTop: '54px',

      ['& .MuiPaper-root']: {
        width: '100%'
      },

      [theme.breakpoints.down(600)]: {
        marginTop: '60px'
      }
    },
    wallBetween: {
      width: '0px',
      height: '22px',
      border: '1px solid rgba(0, 0, 0, 0.2)',
      margin: '0px 29px',

      [theme.breakpoints.down(600)]: {
        margin: '0px 15px'
      }
    },
    submitFiltersBtn: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#2E86BD',
      width: '246px',
      height: '53px',
      margin: 'auto',
      marginTop: '40px',
      borderRadius: '9px',
      fontFamily: 'Montserrat',
      fontSize: '12px',
      fontWeight: 500,
      lineHeight: '15px',
      letterSpacing: '0em',
      color: 'white',
      marginBottom: '13.5px'
    },
    categoriesInput: {
      margin: 0,
      marginBottom: 10,
      height: '46px',
      fontSize: '14px',
      '& label': {
        fontSize: 14,
        marginTop: 2
      }
    }
  })
)
